"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_VALUE_RULE_NAME = "max_value";
exports.Validator = {
    name: exports.MAX_VALUE_RULE_NAME,
    errorMessage: "This field may not be greater than :" + exports.MAX_VALUE_RULE_NAME + ".",
    validate: function (value, requirement) { return Number(value) <= Number(requirement); },
};
